import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AvailableAssessment } from "./generalTypes";

export interface OrganizationAssessments extends AvailableAssessment {
    loading: boolean;
    hasPurchases: boolean;
    hasAssessment: boolean;
}

export const initialState = {
    purchases: 0,
    usedAssessments: 0,
    availableAssessments: 0,
    availableAssessmentPercentage: 0,
    warning: false,
    threshold: 0,
    loading: true,
    hasPurchases: false,
    hasAssessment: false
};

const organizationAssessmentsSlice = createSlice({
    name: "organizationAssessments",
    initialState,
    reducers: {
        updateOrganizationAssessments(state, action: PayloadAction<OrganizationAssessments>) {
            state.purchases = action.payload.purchases;
            state.usedAssessments = action.payload.usedAssessments;
            state.availableAssessments = action.payload.availableAssessments;
            state.availableAssessmentPercentage = action.payload.availableAssessmentPercentage;
            state.warning = action.payload.warning;
            state.threshold = action.payload.threshold;
            state.loading = false;
            state.hasPurchases = action.payload.purchases > 0;
            state.hasAssessment = action.payload.availableAssessments > 0;
        }
    }
});

export const { updateOrganizationAssessments } = organizationAssessmentsSlice.actions;

export default organizationAssessmentsSlice.reducer;
